import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SearchBarComponent } from '../../../../../../../@shared/components/search-bar/search-bar.component';
import { TemplateLibraryService } from '../../../../../../services/template-library.service';
import { ToastService } from '../../../../../../../@core/services/toast.service';
import { ProjectService } from 'src/app/contract-management/services/project.service';
import { IconComponent } from 'src/app/@core/components/ui/icon/icon.component';

export interface IProjectTagType {
    _id: string;
    name: string;
    dataType: string;
}

@Component({
    selector: 'app-add-project-tags',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        SearchBarComponent,
        IconComponent
    ],
    templateUrl: './add-project-tags-dialog.component.html',
    styleUrl: './add-project-tags-dialog.component.scss'
})
export class AddProjectTagsComponent implements OnInit, OnChanges, OnDestroy {
    @Input() visible: boolean = false;
    @Output() onInsert = new EventEmitter<IProjectTagType[]>();
    @Output() onClose = new EventEmitter<void>();

    tagTypes: IProjectTagType[] = [];
    filteredTagTypes: IProjectTagType[] = [];
    searchValue: string = '';
    loading: boolean = false;
    copiedTagId: string | null = null;
    copiedTimeout: any = null;

    constructor(
        private projectService: ProjectService,
        private toast: ToastService
    ) { }

    ngOnInit() {
        if (this.visible) {
            this.loadTagTypes();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['visible'] && changes['visible'].currentValue) {
            this.loadTagTypes();
        }
    }

    loadTagTypes() {
        this.loading = true;
        this.projectService.getProjectTagTypes().subscribe({
            next: (res: any) => {
                if (res.success && res.data) {
                    this.tagTypes = res.data;
                    this.filteredTagTypes = this.tagTypes;
                } else {
                    this.toast.error('Failed to load project tags', 'error');
                }
                this.loading = false;
            },
            error: (err: any) => {
                console.error('Error loading tag types:', err);
                this.toast.error('Failed to load project tags', 'error');
                this.loading = false;
            }
        });
    }

    onSearchChange(value: string) {
        this.searchValue = value;
        this.filterTagTypes();
    }

    filterTagTypes() {
        if (!this.searchValue || this.searchValue.trim() === '') {
            this.filteredTagTypes = this.tagTypes;
        } else {
            const searchTerm = this.searchValue.toLowerCase();
            this.filteredTagTypes = this.tagTypes.filter(tag =>
                tag.name.toLowerCase().includes(searchTerm) ||
                tag.dataType.toLowerCase().includes(searchTerm)
            );
        }
    }

    handleClose() {
        this.onClose.emit();
        this.resetState();
    }

    // onInsertClick() {
    //     const selectedTags = this.tagTypes.filter(tag =>
    //         this.selectedTagTypes.has(tag._id)
    //     );
    //     this.onInsert.emit(selectedTags);
    //     this.resetState();
    // }

    copyTag(tag: IProjectTagType) {
        const tagText = `[${tag.name}]`;
        if (navigator.clipboard) {
            navigator.clipboard.writeText(tagText).then(() => {
                // Clear any existing timeout
                if (this.copiedTimeout) {
                    clearTimeout(this.copiedTimeout);
                }

                // Show "Copied" text
                this.copiedTagId = tag._id;

                // Hide after 3 seconds
                this.copiedTimeout = setTimeout(() => {
                    this.copiedTagId = null;
                }, 3000);
            }).catch(() => {
                this.toast.error('Failed to copy tag');
            });
        }
    }

    resetState() {
        this.searchValue = '';
        this.filteredTagTypes = this.tagTypes;
    }

    ngOnDestroy() {
        // Clean up timeout to prevent memory leaks
        if (this.copiedTimeout) {
            clearTimeout(this.copiedTimeout);
        }
    }
}

